import { LOCATION_SIDEBAR } from './locationSidebar';

export const LOCATIONS_TEMPLATE = `
<div class="flex h-screen overflow-hidden bg-background-light">
${LOCATION_SIDEBAR}
<main class="ml-64 flex-1 overflow-hidden flex flex-col">
  <div class="flex-1 overflow-auto p-8">
    <div class="flex items-end justify-between mb-8">
      <div>
        <h1 class="text-3xl font-black text-slate-900 tracking-tight">Locations</h1>
        <p class="mt-1 text-sm text-slate-500">Manage published points, moderation queue, and user suggestions</p>
      </div>
      <button id="locations-create-btn" class="inline-flex items-center gap-2 h-11 px-6 rounded-lg bg-primary text-white font-bold shadow-sm shadow-primary/20 hover:bg-primary/90 transition-colors" type="button">
        <span class="material-symbols-outlined text-[20px]">add</span>
        <span>Create Location</span>
      </button>
    </div>

    <section class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5 mb-8">
      <article class="bg-white border border-slate-200 rounded-xl p-5 shadow-sm text-center">
        <p class="text-sm text-slate-500 font-medium">Published</p>
        <p id="locations-kpi-published" class="mt-1 text-3xl font-black text-slate-900">0</p>
      </article>
      <article class="bg-white border border-slate-200 rounded-xl p-5 shadow-sm text-center">
        <p class="text-sm text-slate-500 font-medium">Pending Review</p>
        <p id="locations-kpi-pending" class="mt-1 text-3xl font-black text-slate-900">0</p>
      </article>
      <article class="bg-white border border-slate-200 rounded-xl p-5 shadow-sm text-center">
        <p class="text-sm text-slate-500 font-medium">Draft</p>
        <p id="locations-kpi-draft" class="mt-1 text-3xl font-black text-slate-900">0</p>
      </article>
      <article class="bg-white border border-slate-200 rounded-xl p-5 shadow-sm text-center">
        <p class="text-sm text-slate-500 font-medium">Featured</p>
        <p id="locations-kpi-featured" class="mt-1 text-3xl font-black text-slate-900">0</p>
      </article>
    </section>

    <section class="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
      <div class="p-4 border-b border-slate-100">
        <div class="grid grid-cols-1 lg:grid-cols-12 gap-3">
        <div class="relative lg:col-span-4">
          <span class="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">search</span>
          <input id="locations-search-input" class="w-full h-9 pl-10 pr-4 rounded-lg bg-slate-50 border border-slate-200 text-[13px] placeholder:text-slate-400 focus:border-primary focus:ring-primary" placeholder="Search locations..." type="text"/>
        </div>

        <select id="locations-status-filter" class="h-9 lg:col-span-2 px-3 rounded-lg border border-slate-200 bg-slate-50 text-[13px] text-slate-700 focus:border-primary focus:ring-primary">
          <option value="all">Status: All</option>
          <option value="draft">Draft</option>
          <option value="pending_review">Pending Review</option>
          <option value="approved">Approved</option>
          <option value="published">Published</option>
          <option value="rejected">Rejected</option>
          <option value="archived">Archived</option>
          <option value="my_suggestions">My Suggestions</option>
          <option value="moderation_queue">Moderation Queue</option>
        </select>

        <select id="locations-country-filter" class="h-9 lg:col-span-2 px-3 rounded-lg border border-slate-200 bg-slate-50 text-[13px] text-slate-700 focus:border-primary focus:ring-primary">
          <option value="all">Country: All</option>
        </select>

        <select id="locations-region-filter" class="h-9 lg:col-span-2 px-3 rounded-lg border border-slate-200 bg-slate-50 text-[13px] text-slate-700 focus:border-primary focus:ring-primary">
          <option value="all">Region: All</option>
        </select>

        <select id="locations-featured-filter" class="h-9 lg:col-span-2 px-3 rounded-lg border border-slate-200 bg-slate-50 text-[13px] text-slate-700 focus:border-primary focus:ring-primary">
          <option value="all">Featured: All</option>
          <option value="yes">Featured: Yes</option>
          <option value="no">Featured: No</option>
        </select>
        </div>
      </div>

      <div class="px-4 pb-4 flex flex-wrap gap-3 items-center border-b border-slate-100">
        <select id="locations-sort-select" class="h-9 px-3 rounded-lg border border-slate-200 bg-slate-50 text-[13px] text-slate-700 focus:border-primary focus:ring-primary min-w-[180px]">
          <option value="-created_at">Created (Newest)</option>
          <option value="-updated_at">Updated (Newest)</option>
          <option value="-rating_avg">Rating (Highest)</option>
          <option value="title">Title (A-Z)</option>
        </select>
        <input id="locations-rating-min-input" class="h-9 px-3 rounded-lg bg-slate-50 border border-slate-200 text-[13px] w-32" placeholder="Min rating" type="text"/>
        <input id="locations-tags-input" class="h-9 px-3 rounded-lg bg-slate-50 border border-slate-200 text-[13px] w-40" placeholder="Tag ids: 1,2" type="text"/>
        <input id="locations-bbox-input" class="h-9 px-3 rounded-lg bg-slate-50 border border-slate-200 text-[13px] w-64" placeholder="bbox minLon,minLat,maxLon,maxLat" type="text"/>
        <input id="locations-center-lat-input" class="h-9 px-3 rounded-lg bg-slate-50 border border-slate-200 text-[13px] w-24" placeholder="Lat" type="text"/>
        <input id="locations-center-lon-input" class="h-9 px-3 rounded-lg bg-slate-50 border border-slate-200 text-[13px] w-24" placeholder="Lon" type="text"/>
        <input id="locations-radius-input" class="h-9 px-3 rounded-lg bg-slate-50 border border-slate-200 text-[13px] w-20" placeholder="Km" type="text"/>
        <button id="locations-reset-filters-btn" class="h-9 px-3 rounded-lg border border-slate-200 text-[13px] font-semibold text-primary hover:bg-primary/5" type="button">Reset</button>
      </div>

      <div class="overflow-x-auto">
        <table class="w-full text-left">
          <thead class="bg-slate-50 text-slate-500 uppercase text-[11px] font-bold tracking-wider">
            <tr>
              <th class="px-6 py-4">ID</th>
              <th class="px-6 py-4">Title & Location</th>
              <th class="px-6 py-4">Status</th>
              <th class="px-6 py-4 text-center">Featured</th>
              <th class="px-6 py-4">Stats</th>
              <th class="px-6 py-4">Submitter</th>
              <th class="px-6 py-4 text-right">Actions</th>
            </tr>
          </thead>
          <tbody id="locations-table-body" class="divide-y divide-slate-100">
            <tr>
              <td class="px-6 py-10 text-center text-sm text-slate-500" colspan="7">Loading locations...</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="border-t border-slate-100 px-6 py-3 flex items-center justify-between gap-4">
        <p id="locations-results-meta" class="text-xs text-slate-500 font-medium">Showing 0 of 0 results</p>
        <div class="flex items-center gap-2">
          <button id="locations-prev-btn" class="px-3 py-1.5 rounded-lg border border-slate-200 text-slate-600 hover:bg-white text-sm disabled:opacity-50 disabled:cursor-not-allowed" type="button">Prev</button>
          <span id="locations-page-indicator" class="text-xs font-semibold text-slate-500 min-w-[72px] text-center">Page 1</span>
          <button id="locations-next-btn" class="px-3 py-1.5 rounded-lg border border-slate-200 text-slate-600 hover:bg-white text-sm disabled:opacity-50 disabled:cursor-not-allowed" type="button">Next</button>
        </div>
      </div>
    </section>
  </div>
</main>
<div id="locations-view-overlay" class="hidden fixed inset-0 z-[70] bg-black/35 backdrop-blur-[1px]">
<div class="absolute inset-y-0 right-0 w-full md:w-1/2 bg-white shadow-2xl flex flex-col">
<div class="flex items-center justify-between border-b border-slate-100 px-6 py-4">
<div class="flex items-center gap-3">
<h3 id="locations-view-title" class="text-xl font-bold text-slate-900">Location</h3>
<span id="locations-view-status" class="inline-flex items-center rounded-full bg-slate-100 px-2.5 py-0.5 text-xs font-semibold text-slate-700">Loading</span>
</div>
<button id="locations-view-close-btn" class="flex h-8 w-8 items-center justify-center rounded-full text-slate-400 hover:bg-slate-100 hover:text-slate-600 transition-colors" type="button">
<span class="material-symbols-outlined">close</span>
</button>
</div>
<div class="flex-1 overflow-y-auto p-6">
<div class="group relative overflow-hidden rounded-xl bg-slate-100 aspect-video">
<img id="locations-view-hero-image" alt="Location media" class="h-full w-full object-cover" src="data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='1200' height='675'><rect width='100%' height='100%' fill='%23e2e8f0'/></svg>"/>
<div class="absolute bottom-4 left-4 flex items-center gap-2 rounded-lg bg-black/60 px-3 py-1.5 text-white backdrop-blur-md">
<span class="material-symbols-outlined text-[18px] text-amber-400" style="font-variation-settings: 'FILL' 1;">star</span>
<span id="locations-view-rating" class="text-sm font-bold">0.00</span>
<span id="locations-view-reviews" class="text-xs text-white/70">(0 Reviews)</span>
</div>
</div>
<div id="locations-view-thumbnails" class="mt-4 grid grid-cols-4 gap-3"></div>
<div class="mt-6 grid grid-cols-2 gap-y-6 border-b border-slate-100 pb-6">
<div>
<p class="text-[10px] font-bold uppercase tracking-wider text-slate-400">Coordinates</p>
<p id="locations-view-coordinates" class="mt-1 text-sm font-medium text-primary">-</p>
</div>
<div>
<p class="text-[10px] font-bold uppercase tracking-wider text-slate-400">Country / Region</p>
<p id="locations-view-region" class="mt-1 text-sm font-medium text-slate-900">-</p>
</div>
<div class="col-span-2">
<p class="text-[10px] font-bold uppercase tracking-wider text-slate-400 mb-2">Attributes</p>
<div id="locations-view-attributes" class="flex flex-wrap gap-2"></div>
</div>
</div>
<div class="grid grid-cols-2 gap-x-6 gap-y-4 border-b border-slate-100 py-6">
<div>
<p class="text-[10px] font-bold uppercase tracking-wider text-slate-400">Slug</p>
<p id="locations-view-slug" class="mt-1 text-sm font-medium text-slate-800">-</p>
</div>
<div>
<p class="text-[10px] font-bold uppercase tracking-wider text-slate-400">Source</p>
<p id="locations-view-source" class="mt-1 text-sm font-medium text-slate-800">-</p>
</div>
<div>
<p class="text-[10px] font-bold uppercase tracking-wider text-slate-400">Submitter</p>
<p id="locations-view-submitter" class="mt-1 text-sm font-medium text-slate-800">-</p>
</div>
<div>
<p class="text-[10px] font-bold uppercase tracking-wider text-slate-400">Location Name</p>
<p id="locations-view-location-name" class="mt-1 text-sm font-medium text-slate-800">-</p>
</div>
<div>
<p class="text-[10px] font-bold uppercase tracking-wider text-slate-400">County</p>
<p id="locations-view-county" class="mt-1 text-sm font-medium text-slate-800">-</p>
</div>
<div>
<p class="text-[10px] font-bold uppercase tracking-wider text-slate-400">Settlement</p>
<p id="locations-view-settlement" class="mt-1 text-sm font-medium text-slate-800">-</p>
</div>
</div>
<div class="py-6">
<p class="text-[10px] font-bold uppercase tracking-wider text-slate-400 mb-2">Description</p>
<div id="locations-view-description" class="space-y-3 text-sm leading-relaxed text-slate-600"></div>
</div>
<div class="border-t border-slate-100 py-6">
<p class="text-[10px] font-bold uppercase tracking-wider text-slate-400 mb-2">Safety Notes</p>
<p id="locations-view-safety-notes" class="text-sm leading-relaxed text-slate-600">-</p>
</div>
<div class="border-t border-slate-100 py-6">
<p class="text-[10px] font-bold uppercase tracking-wider text-slate-400 mb-2">Access Rules</p>
<p id="locations-view-access-rules" class="text-sm leading-relaxed text-slate-600">-</p>
</div>
<div class="border-t border-slate-100 py-6">
<p class="text-[10px] font-bold uppercase tracking-wider text-slate-400 mb-2">Quick Facts</p>
<div id="locations-view-facts" class="space-y-1 text-sm text-slate-700"></div>
</div>
<div class="border-t border-slate-100 py-6">
<div class="mb-3 flex items-center justify-between">
<p class="text-[10px] font-bold uppercase tracking-wider text-slate-400">Reviews</p>
<p id="locations-view-reviews-count" class="text-xs font-medium text-slate-500">0</p>
</div>
<div id="locations-view-reviews-list" class="space-y-2"></div>
</div>
<div class="grid grid-cols-2 gap-x-6 gap-y-4 border-t border-slate-100 py-6">
<div>
<p class="text-[10px] font-bold uppercase tracking-wider text-slate-400">Review Comment</p>
<p id="locations-view-review-comment" class="mt-1 text-sm font-medium text-slate-800">-</p>
</div>
<div>
<p class="text-[10px] font-bold uppercase tracking-wider text-slate-400">Archived</p>
<p id="locations-view-archived" class="mt-1 text-sm font-medium text-slate-800">-</p>
</div>
<div>
<p class="text-[10px] font-bold uppercase tracking-wider text-slate-400">Created At</p>
<p id="locations-view-created-at" class="mt-1 text-sm font-medium text-slate-800">-</p>
</div>
<div>
<p class="text-[10px] font-bold uppercase tracking-wider text-slate-400">Updated At</p>
<p id="locations-view-updated-at" class="mt-1 text-sm font-medium text-slate-800">-</p>
</div>
<div>
<p class="text-[10px] font-bold uppercase tracking-wider text-slate-400">Published At</p>
<p id="locations-view-published-at" class="mt-1 text-sm font-medium text-slate-800">-</p>
</div>
<div>
<p class="text-[10px] font-bold uppercase tracking-wider text-slate-400">Rating Count</p>
<p id="locations-view-rating-count" class="mt-1 text-sm font-medium text-slate-800">-</p>
</div>
</div>
</div>
<div class="border-t border-slate-100 bg-slate-50 px-6 py-4 flex items-center gap-3">
<button id="locations-view-edit-btn" class="flex flex-1 items-center justify-center gap-2 rounded-lg bg-primary py-2.5 text-sm font-bold text-white shadow-sm hover:bg-primary/90 transition-all" type="button">
<span class="material-symbols-outlined text-[18px]">edit</span>
Edit Entry
</button>
<button id="locations-view-delete-btn" class="flex h-[42px] w-[42px] items-center justify-center rounded-lg border border-red-100 bg-white text-red-500 hover:bg-red-50 transition-all" type="button">
<span class="material-symbols-outlined">delete</span>
</button>
</div>
</div>
</div>
</div>
`;
